var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 pa-md-2 ma-0"},[_c('v-row',{staticClass:"d-flex"},[_c('v-col',{staticClass:"recruiting-label pt-2",attrs:{"cols":"4"}},[_vm._v(_vm._s(_vm.label))]),_c('v-col',{staticClass:"recruiting-bio pt-1"},[_vm._t("default",function(){return [_vm._v("DATA")]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }